'use client';
import InputLabel from '@mui/material/InputLabel';
import { styled } from '@mui/material/styles';

export const SelectInputLabel = styled(InputLabel)(({ theme }) => ({
    maxWidth: `calc(100% - ${theme.spacing(5)})`,
}));
